module.exports = __webpack_public_path__ + "img/4e22b.932cc09a.svg";